<template>
<div style="width:760px;height:570px;">
  <div style="position: relative;width:100%;height:100%;" v-if="ofd_detail.url && ofd_detail.url.indexOf('ofd') != -1">
    <img src="../../assets/images/zhang1.gif" class="yiguidang" v-if="ofd_detail.is_place && ofd_detail.is_place==2">
    <img src="../../assets/images/zhang4.gif" class="yiguidang" v-if="ofd_detail.is_really && ofd_detail.is_really==1">
    <div :id="'ofd_content'" width="100%" style="border:#ccc 1px solid;">
      <div :class="'seal_img_div'"></div>
    </div>
  </div>
</div>
</template>

<script>
  import { parseOfdDocument, renderOfd } from "../../utils/ofd/ofd"
  export default {
  props: ['ofd_detail', 'closeMain'],
  data() {
    return {
    }
  },
  methods: {
    look_ofd() {
      let that = this
      var name = this.ofd_detail.url
      parseOfdDocument({
        ofd: this.readUrl + name,
        success(res) {
          //输出ofd每页的div
          console.log(res)
          const divs = renderOfd(758, res[0])
          let contentDiv = document.getElementById('ofd_content')
          contentDiv.innerHTML = ''
          for (const div of divs) {
            contentDiv.appendChild(div)
          }
          for (let ele of document.getElementsByName('seal_img_div')) {
            this.addEventOnSealDiv(ele, JSON.parse(ele.dataset.sesSignature), JSON.parse(ele.dataset.signedInfo));
          }
        }
      })
    },
    close_dig() {
      this.$emit('closeMain', 0)
    }
  },
  created() {
    if (this.ofd_detail.url && this.ofd_detail.url.indexOf('ofd') != -1) {
      this.look_ofd()
    }
  },
  computed:{
    ofd_id(){
        return this.ofd_detail.id
    }        
  },
  watch: {
    ofd_id(val){
         this.look_ofd()
    }
  },
  components: {
    parseOfdDocument,
    renderOfd
  },
}
</script>



// WEBPACK FOOTER //
// ofd.vue?e0783156